export default __webpack_public_path__ + "static/media/Quotefancy-5032599-3840x2160.3d9ccf57.jpg";